import { useCallback } from 'react';

// useTooltipNonmetallic предоставляет функции для отображения подсказок с производством для нерудных материалов
export const useTooltipNonmetallic = (setTooltip, tableContainerRef, selectedOffer, productionInfo) => {
  // Обработчик наведения мыши на элемент
  const handleMouseEnter = useCallback((event, material) => {
    const targetElement = event.currentTarget;
    const rect = targetElement.getBoundingClientRect();

    // Получаем название производства
    const production = material.manufacturer || selectedOffer?.production || 'Не указано';

    console.log('🔍 useTooltipNonmetallic productionInfo:', productionInfo);

    // Создаем содержимое tooltip с названием производства и дополнительной информацией
    let tooltipContent = production;

    // Добавляем дополнительную информацию, если она есть
    if (productionInfo) {
      // Проверяем структуру как в ProductionsTableNonmetallic (ADDITIONAL_INFO)
      if (productionInfo.ADDITIONAL_INFO) {
        tooltipContent += `\n${productionInfo.ADDITIONAL_INFO}`;
      }
      // Или как планировалось изначально (address, working_hours)
      else {
        if (productionInfo.address) {
          tooltipContent += `\n${productionInfo.address}`;
        }
        if (productionInfo.working_hours) {
          tooltipContent += `\n${productionInfo.working_hours}`;
        }
      }
    }

    // Позиция в координатах viewport (Tooltip использует position: fixed).
    // Центрируем по горизонтали и ставим над элементом.
    const x = rect.left + rect.width / 2;
    const y = rect.top;

    setTooltip({
      visible: true,
      text: tooltipContent.replace(/\n/g, '<br/>'),
      x,
      y,
      targetElement,
    });
  }, [setTooltip, tableContainerRef, selectedOffer, productionInfo]);

  // Обработчик ухода мыши с элемента
  const handleMouseLeave = useCallback(() => {
    setTooltip({ visible: false, text: "", x: 0, y: 0, targetElement: null });
  }, [setTooltip]);

  return { handleMouseEnter, handleMouseLeave };
};